import { IProduct, IProductInfo, IProductVariations } from '../../models';
import { useTranslation } from 'react-i18next';
import InfoButton from '../InfoButton';
import { SYMBOLS } from '../../helpers/symbolsMap';

export default function ProductMoreInfo({
  product,
  shippmentAndReturnInfoText,
  setSection,
  variant
}: {
  product: IProduct;
  shippmentAndReturnInfoText: string;
  setSection: any;
  variant: IProductVariations | undefined;
}) {
  const { t } = useTranslation();
  const { productInfo, bullet_list = [], technologies = [] } = product || {};
  const { MoreInfo = [] } = productInfo || ({} as IProductInfo);

  return (
    <>
      <div className="mt-10">
        {bullet_list.some(Boolean) && (
          <InfoButton
            text={t('FEATURES')}
            onClick={() =>
              setSection({
                ContentComponent: function ContentComponent() {
                  return (
                    <>
                      <h3 className="uppercase mb-2 text-bold">
                        {t('FEATURES')}
                      </h3>
                      {bullet_list.map((bullet, i) => (
                        <p
                          key={i}
                          className="font-normal mb-2"
                          dangerouslySetInnerHTML={{ __html: bullet }}
                        />
                      ))}
                    </>
                  );
                }
              })
            }
          />
        )}
        <div className="-mt-px">
          <InfoButton
            text={t('MATERIALS_AND_TECHNOLOGIES')}
            onClick={() =>
              setSection({
                ContentComponent: function ContentComponent() {
                  return (
                    <>
                      <h3 className="uppercase mb-2 text-bold">
                        {t('MATERIALS_AND_TECHNOLOGIES')}
                      </h3>
                      {
                        <>
                          {variant?.compositions?.map((c, i) => (
                            <p key={i} className="text-gray-700 font-normal">
                              {c.compositionType}:<br />
                              <span>
                                {c.composition?.map((child, k) => (
                                  <span
                                    key={k}
                                    className="text-gray-400 font-normal"
                                  >
                                    {child.percentage || 0}%{' '}
                                    {child.composition || ''}{' '}
                                  </span>
                                ))}
                              </span>
                            </p>
                          ))}
                        </>
                      }
                      {/* {technologies?.map((tech, i) => (
                        <div key={i} className="py-2">
                          <h3 className="uppercase my-1 text-bold">
                            {tech.name}
                          </h3>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: tech.description
                            }}
                          ></div>
                        </div>
                      ))} */}
                    </>
                  );
                }
              })
            }
          />
        </div>
        {shippmentAndReturnInfoText && (
          <div className="-mt-px">
            <InfoButton
              text={t('SHIPPING_AND_WITHDRAWALS')}
              onClick={() =>
                setSection({
                  ContentComponent: function ContentComponent() {
                    return (
                      <>
                        <h3 className="uppercase mb-2 text-bold">
                          {t('SHIPPING_AND_WITHDRAWALS')}
                        </h3>
                        <div
                          className="font-normal"
                          dangerouslySetInnerHTML={{
                            __html: shippmentAndReturnInfoText
                          }}
                        />
                      </>
                    );
                  }
                })
              }
            />
          </div>
        )}
        {MoreInfo &&
          MoreInfo.map(({ name, items }, i) => (
            <div className="-mt-px" key={i}>
              <InfoButton
                text={name}
                onClick={() =>
                  setSection({
                    ContentComponent: function ContentComponent() {
                      return (
                        <>
                          <h3 className="uppercase mb-2 text-black">{name}</h3>
                          {items.map(({ istruction, symbol }) => (
                            <p key={symbol} className="font-normal">
                              <span className="font-aaaaregular mr-2">
                                {SYMBOLS[symbol]}
                              </span>{' '}
                              {istruction}
                            </p>
                          ))}
                        </>
                      );
                    }
                  })
                }
              />
            </div>
          ))}
      </div>
    </>
  );
}
